export const CollectionQueryKey = {
    authorCollection: (username: string, slug: string) => ['author', username, 'collections', slug],
    authorCollectionSimple: (username: string, slug: string) => [
        ...CollectionQueryKey.authorCollection(username, slug),
        'simple',
    ],
    collectionSuggestions: (username: string, slug: string) => [
        'collection',
        'suggestions',
        username,
        slug,
    ],
    anyCollectionAudios: () => ['collection', 'audios'],
    collectionAudiosPrefix: (username: string, slug: string) => [
        ...CollectionQueryKey.anyCollectionAudios(),
        username,
        slug,
    ],
    collectionAudios: (username: string, slug: string, page: number) => [
        ...CollectionQueryKey.collectionAudiosPrefix(username, slug),
        page,
    ],
    authorCollections: (username: string) => ['author', username, 'collections'],
    authorPaginatedCollections: (username: string) => ['author', username, 'paginated-collections'],
}
